// === RECOMENDADOR SUPRABODIES JS (Versión 5 - CORREGIDA - desde Base Okey v1.0) ===
// Base: v4 (Validación edad mínima)
// Cambios v5 CORREGIDA: Corregida apiUrl de producción (añadido /recommendations).

document.addEventListener('DOMContentLoaded', function() {
    // Referencias a elementos del DOM
    const initialInputArea = document.getElementById('initial-input-area');
    const initialSubmitBtn = document.getElementById('initial-submit-btn');
    const finalSubmitBtn = document.getElementById('final-submit-btn');
    const initialResultsDiv = document.getElementById('initial-results');
    const finalProductResultsDiv = document.getElementById('final-product-results');
    const resultsAndGoalsArea = document.getElementById('results-and-goals-area');
    const optionalGoalsSection = document.getElementById('optional-goals-section');

    let calculatedDataForApi = {};

    // --- Listener para el PRIMER Botón: Obtener Análisis Inicial ---
    if (initialSubmitBtn) {
        initialSubmitBtn.addEventListener('click', async function() {
            clearResults();
            initialResultsDiv.innerHTML = '<p>Calculando tu peso ideal...</p>';
            if(resultsAndGoalsArea) resultsAndGoalsArea.style.display = 'block';

            // --- Recolección y Validación ---
            const nameInput = document.getElementById('name');
            const genderSelect = document.getElementById('gender');
            const ageInput = document.getElementById('age');
            const heightInput = document.getElementById('height');
            const weightInput = document.getElementById('weight');
            const contexturaRadio = document.querySelector('input[name="contextura"]:checked');

            const name = nameInput ? nameInput.value.trim() : '';
            const gender = genderSelect ? genderSelect.value : '';
            const age = ageInput ? ageInput.value : '';
            const height = heightInput ? heightInput.value : '';
            const weight = weightInput ? weightInput.value : '';

            if (!name || !gender || !age || !height || !weight || !contexturaRadio) {
                mostrarErrorInicial('Por favor, complete todos los campos obligatorios (Nombre, Género, Edad, Estatura, Peso y Contextura).');
                return;
            }
            const contextura = contexturaRadio.value;

            // --- Validaciones Numéricas y de Rango ---
            const nAge = parseInt(age, 10);
            const nHeight = parseInt(height, 10);
            const nWeight = parseFloat(weight);
            const validationErrorPrefix = 'Valor inválido para ';

            if (isNaN(nAge) || nAge < 1 || nAge > 120) { mostrarErrorInicial(validationErrorPrefix + 'Edad.'); return; }
            if (isNaN(nHeight) || nHeight < 50 || nHeight > 250) { mostrarErrorInicial(validationErrorPrefix + 'Estatura.'); return; }
            if (isNaN(nWeight) || nWeight < 20 || nWeight > 300) { mostrarErrorInicial(validationErrorPrefix + 'Peso.'); return; }

            // --- VALIDACIÓN EDAD MÍNIMA (v4) ---
            if (nAge < 18) {
                const mensajeEdadMinima = "Lo sentimos, este recomendador está diseñado para personas mayores de 18 años.\n\nEl motivo es que el Índice de Masa Corporal (IMC) en menores de edad se interpreta de manera distinta, ya que su cuerpo aún está en desarrollo. Para niños y adolescentes se utilizan tablas específicas que consideran la edad y el sexo, por lo que una herramienta genérica como esta podría dar resultados incorrectos o confusos.";
                mostrarErrorInicial(mensajeEdadMinima);
                return;
            }
            // --- FIN VALIDACIÓN EDAD MÍNIMA ---

            const alturaMetros = nHeight / 100;
            const imc = nWeight / (alturaMetros * alturaMetros);
            let geb;
             if (gender === 'Masculino') { geb = parseFloat(((10 * nWeight) + (6.25 * nHeight) - (5 * nAge) + 5).toFixed(2)); }
             else if (gender === 'Femenino') { geb = parseFloat(((10 * nWeight) + (6.25 * nHeight) - (5 * nAge) - 161).toFixed(2)); }
             else { geb = null; }

            const initialDataToSend = {
                imc: parseFloat(imc.toFixed(2)), height: nHeight, contextura: contextura.toLowerCase(),
                geb: geb, gender: gender.toLowerCase()
            };

             // --- URL DE LA API CORREGIDA (v5 CORREGIDA) ---
             const apiUrl = 'https://recomendador-fuxion-api.onrender.com/recommendations?stage=initial'; // <-- Añadido /recommendations
             console.log("Enviando a API (Etapa Inicial - Render):", JSON.stringify(initialDataToSend));

            try {
                const response = await fetch(apiUrl, {
                    method: 'POST', headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(initialDataToSend)
                });

                if (!response.ok) {
                   const errorData = await response.json().catch(() => ({}));
                   console.error("Error API:", response.status, errorData);
                   throw new Error(`Error ${response.status}: ${errorData.error || response.statusText}`);
                }

                const initialApiData = await response.json();
                console.log("Respuesta API (Etapa Inicial - Render):", initialApiData);

                calculatedDataForApi = {
                    imc: initialApiData.imc, height: nHeight, contextura: contextura.toLowerCase(),
                    geb: initialApiData.geb, gender: gender.toLowerCase()
                };

                // --- Actualización de la UI ---
                if (initialInputArea) { initialInputArea.style.display = 'none'; }
                mostrarInitialResults(initialApiData);
                if(optionalGoalsSection) optionalGoalsSection.style.display = 'block';
                if(finalSubmitBtn) finalSubmitBtn.style.display = 'inline-block';

                 if (resultsAndGoalsArea) {
                     setTimeout(() => { resultsAndGoalsArea.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 50);
                 }

            } catch (error) {
                console.error("Error en llamada API inicial:", error);
                mostrarErrorInicial(`No se pudo obtener el análisis inicial. ${error.message}. Por favor, revise los datos o intente más tarde.`);
                 if (initialResultsDiv) {
                     setTimeout(() => { initialResultsDiv.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 50);
                 }
            }
        });
    } else { console.error("Botón #initial-submit-btn no encontrado."); }

    // --- Listener para el SEGUNDO Botón: Ver Productos Recomendados ---
    if(finalSubmitBtn) {
        finalSubmitBtn.addEventListener('click', async function() {
            finalProductResultsDiv.innerHTML = '<p>Buscando productos recomendados...</p>';
            finalProductResultsDiv.style.display = 'block';

            const selectedGoals = [];
            const goalCheckboxes = document.querySelectorAll('#optional-goals-section input[name="optional_goals"]:checked');
            goalCheckboxes.forEach(checkbox => { selectedGoals.push(checkbox.value); });
            console.log("Objetivos opcionales seleccionados:", selectedGoals);

            if (!calculatedDataForApi || Object.keys(calculatedDataForApi).length === 0) {
                 mostrarErrorFinal("Error interno: Faltan datos del análisis inicial. Por favor, vuelva al primer paso.");
                 return;
            }

            const finalDataForApi = { ...calculatedDataForApi, optional_goals: selectedGoals };

             // --- URL DE LA API CORREGIDA (v5 CORREGIDA) ---
            const apiUrl = 'https://recomendador-fuxion-api.onrender.com/recommendations?stage=final'; // <-- Añadido /recommendations
            // const apiUrl = 'https://recomendador-fuxion-api.onrender.com/recommendations'; // Alternativa si el endpoint final no necesita stage
            console.log("Enviando payload final a API (Render):", JSON.stringify(finalDataForApi));

            try {
                const response = await fetch(apiUrl, {
                    method: 'POST', headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(finalDataForApi)
                });

                if (!response.ok) {
                    const errorData = await response.json().catch(() => ({}));
                    console.error("Error API:", response.status, errorData);
                    throw new Error(`Error ${response.status}: ${errorData.error || response.statusText}`);
                }

                const finalRecommendations = await response.json();
                console.log("Respuesta final de la API (Render):", finalRecommendations);

                // --- Actualización de la UI ---
                if (initialResultsDiv) initialResultsDiv.style.display = 'none';
                if (optionalGoalsSection) optionalGoalsSection.style.display = 'none';
                if (finalSubmitBtn) finalSubmitBtn.style.display = 'none';

                mostrarFinalProducts(finalRecommendations); // Usa v3 (sin target blank en Más Info)

                 if (finalProductResultsDiv) {
                     setTimeout(() => { finalProductResultsDiv.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 50);
                 }

            } catch (error) {
                console.error('Error al obtener recomendaciones finales:', error);
                mostrarErrorFinal(`No se pudieron obtener los productos recomendados. ${error.message}. Intente más tarde.`);
                 if (finalProductResultsDiv) {
                     setTimeout(() => { finalProductResultsDiv.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 50);
                 }
            }
        });
    } else { console.error("Botón #final-submit-btn no encontrado."); }

}); // Fin DOMContentLoaded

// --- FUNCIONES AUXILIARES ---
// ... (Las funciones auxiliares: clearResults, mostrarInitialResults, mostrarFinalProducts, mostrarErrorInicial, mostrarErrorFinal NO CAMBIAN) ...
function clearResults() {
    const initialResultsDiv = document.getElementById('initial-results');
    const finalProductResultsDiv = document.getElementById('final-product-results');
    if(initialResultsDiv) initialResultsDiv.innerHTML = '';
    if(finalProductResultsDiv) finalProductResultsDiv.innerHTML = '';
}

function mostrarInitialResults(data) {
    const initialResultsDiv = document.getElementById('initial-results');
    if (!initialResultsDiv) return;
     initialResultsDiv.style.display = 'block';
    let output = `<div class="initial-results-card">`;
    output += `<h2>ESTE ES TU DIAGNÓSTICO</h2>`;
    output += `<div class="results-metrics">`;
    output += `<div class="metric-block"><span class="metric-label">Índice de Masa Corporal</span><span class="metric-value">${data.imc ? data.imc.toFixed(2) : 'N/A'}</span></div>`;
    output += `<div class="metric-block"><span class="metric-label">Gasto Energético Basal</span><span class="metric-value">${data.geb ? Math.round(data.geb) : 'N/A'}</span> <span class="metric-unit">kcal/día</span></div>`;
    output += `</div>`;
    output += `<div class="results-classification"><p><span class="classification-label">Peso:</span> <span class="classification-text">${data.clasificacion || 'N/A'}</span></p></div>`;
    if (data.descripcion) {
        output += `<div class="results-description"><p><span class="description-text">${data.descripcion}</span></p></div>`;
    }
    if (data.peso_ideal_min !== undefined && data.peso_ideal_max !== undefined) {
        output += `<div class="results-ideal-weight">`;
        output += `<span class="ideal-weight-label">Rango de Peso Ideal:</span>`;
        output += `<div class="ideal-weight-values">`;
        output += `<div class="weight-item"><span class="weight-label">Mínimo</span> <span class="weight-value">${data.peso_ideal_min} kg</span></div>`;
        output += `<div class="weight-item"><span class="weight-label">Máximo</span> <span class="weight-value">${data.peso_ideal_max} kg</span></div>`;
        output += `</div></div>`;
    }
     output += `</div>`;
    initialResultsDiv.innerHTML = output;
}

function mostrarFinalProducts(recommendations) {
    const finalProductResultsDiv = document.getElementById('final-product-results');
    if (!finalProductResultsDiv) return;
    finalProductResultsDiv.style.display = 'block';

    let productsOutput = '';
    productsOutput += '<h3>TE RECOMENDAMOS ESTAS BEBIDAS</h3>';

    if (recommendations && recommendations.productos && Array.isArray(recommendations.productos) && recommendations.productos.length > 0) {
        productsOutput += '<ul>';
        recommendations.productos.forEach(producto => {
            if (typeof producto === 'object' && producto !== null && producto.id) {
                const productHandle = producto.handle;
                const productUrl = productHandle ? `/products/${productHandle}` : '#';
                let productText = producto.title || 'Nombre no disponible';

                productsOutput += '<li>';
                productsOutput += `<a href="${productUrl}" target="_blank" class="product-main-link">`;
                if (producto.image_url) {
                    productsOutput += `<img src="${producto.image_url}" alt="${producto.title || 'Producto'}">`;
                } else {
                    productsOutput += `<div class="product-image-placeholder">Sin imagen</div>`;
                }
                productsOutput += `<span>${productText}</span>`;
                productsOutput += '</a>';
                productsOutput += `<a href="${productUrl}" class="product-info-btn">MÁS INFO</a>`;
                productsOutput += '</li>';
            } else { console.warn("Elemento inválido o sin ID en la lista de productos:", producto); }
        });
        productsOutput += '</ul>';
    } else {
        if (recommendations && recommendations.productos) {
            productsOutput += "<p>No se encontraron productos específicos para tus objetivos actuales, pero puedes explorar nuestras categorías.</p>";
        } else {
            productsOutput += "<p>Hubo un problema al cargar las recomendaciones de productos.</p>";
            console.warn("La respuesta de la API final no contenía una lista de productos válida:", recommendations);
        }
    }

    finalProductResultsDiv.innerHTML = productsOutput;

    const whatsappBannerHTML = `
      <div class="whatsapp-cta-banner">
        <a href="https://wa.me/34644340088" target="_blank" rel="noopener noreferrer sponsored" class="boton-whatsapp-enlace">
          <img src="https://cdn.shopify.com/s/files/1/0855/9906/0302/files/BOTON_DUDAS.png?v=1742388990" alt="¿Necesitas más información? WhatsApp" class="whatsapp-imagen-boton">
        </a>
      </div>
    `;
    finalProductResultsDiv.insertAdjacentHTML('beforeend', whatsappBannerHTML);

}

function mostrarErrorInicial(mensaje) {
    const initialResultsDiv = document.getElementById('initial-results');
    if (initialResultsDiv) {
        initialResultsDiv.style.display = 'block';
        initialResultsDiv.innerHTML = `<p class="error-message">${mensaje.replace(/\n/g, '<br>')}</p>`;
        if(document.getElementById('optional-goals-section')) document.getElementById('optional-goals-section').style.display = 'none';
        if(document.getElementById('final-submit-btn')) document.getElementById('final-submit-btn').style.display = 'none';
    } else { console.error("Div 'initial-results' no encontrado para mostrar error"); }
}

function mostrarErrorFinal(mensaje) {
    const finalProductResultsDiv = document.getElementById('final-product-results');
     if (finalProductResultsDiv) {
        finalProductResultsDiv.style.display = 'block';
        finalProductResultsDiv.innerHTML = `<p class="error-message">${mensaje.replace(/\n/g, '<br>')}</p>`;
     } else { console.error("Div 'final-product-results' no encontrado para mostrar error"); }
}

// --- FIN CÓDIGO JS ---